import _styled from "styled-components";
import styled, { useTheme } from "styled-components";
import { Li } from "../../Styled/List";
import Icon, { StyledIcon } from "../../Styled/Icon";
import highlightKeyword from "../ReactViewHelpers/highlightKeyword";
import Box, { BoxSpan } from "../../Styled/Box";
import { TextSpan } from "../../Styled/Text";
import Spacing, { SpacingSpan } from "../../Styled/Spacing";
import { RawButton } from "../../Styled/Button";
import Hr from "../../Styled/Hr";

// Not sure how to generalise this or if it should be kept in stlyed/Button.jsx

// Initially had this as border bottom on the button, but need a HR given it's not a full width border
// // ${p => !p.isLastResult && `border-bottom: 1px solid ${p.theme.greyLighter};`}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const RawButtonAndHighlight = styled(RawButton).withConfig({
  displayName: "SearchResult__RawButtonAndHighlight",
  componentId: "sc-16mgcck-0"
})(["", ""], p => "\n  &:hover, &:focus {\n    background-color: ".concat(p.theme.greyLighter, ";\n    ").concat(StyledIcon, " {\n      fill-opacity: 1;\n    }\n  }"));
const SearchResult = props => {
  const theme = useTheme();
  const highlightedResultName = highlightKeyword(props.name, props.locationSearchText);
  const isLightTheme = true;
  const isDarkTheme = false;
  return /*#__PURE__*/_jsx(Li, {
    children: /*#__PURE__*/_jsx(Box, {
      fullWidth: true,
      column: true,
      children: /*#__PURE__*/_jsxs(RawButtonAndHighlight, {
        type: "button",
        onClick: props.clickAction,
        fullWidth: true,
        children: [/*#__PURE__*/_jsxs(BoxSpan, {
          children: [/*#__PURE__*/_jsx(SpacingSpan, {
            right: 2
          }), /*#__PURE__*/_jsx(Hr, {
            size: 1,
            fullWidth: true,
            borderBottomColor: theme.greyLighter
          }), /*#__PURE__*/_jsx(SpacingSpan, {
            right: 2
          })]
        }), /*#__PURE__*/_jsx(TextSpan, {
          breakWord: true,
          large: true,
          textDark: isLightTheme,
          children: /*#__PURE__*/_jsxs(BoxSpan, {
            paddedRatio: 2,
            paddedVertically: 3,
            centered: true,
            justifySpaceBetween: true,
            children: [props.icon && /*#__PURE__*/_jsx(StyledIcon
            // (You need light text on a dark theme, and vice versa)
            , {
              fillColor: isLightTheme && theme.textDarker,
              light: isDarkTheme,
              styledWidth: "16px",
              glyph: Icon.GLYPHS[props.icon]
            }), /*#__PURE__*/_jsx(Spacing, {
              right: 2
            }), /*#__PURE__*/_jsx(BoxSpan, {
              fullWidth: true,
              children: /*#__PURE__*/_jsx(TextSpan, {
                noFontSize: true,
                textAlignLeft: true,
                children: highlightedResultName
              })
            }), /*#__PURE__*/_jsx(_StyledStyledIcon, {
              // (You need light text on a dark theme, and vice versa)
              fillColor: isLightTheme && theme.textDarker,
              light: isDarkTheme,
              styledWidth: "14px",
              glyph: Icon.GLYPHS.right2,
              $_css: "fill-opacity:0;"
            })]
          })
        })]
      })
    })
  });
};
export default SearchResult;
var _StyledStyledIcon = styled(StyledIcon).withConfig({
  displayName: "SearchResult___StyledStyledIcon",
  componentId: "sc-16mgcck-1"
})(["", ""], p => p.$_css);